import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GazeMapConfig, GazeMapSettings } from '../models/gaze-map';
import * as utils from '../../shared/helpers/utils';

@Injectable({
  providedIn: 'root'
})
export class GazeMapService {

  GazeMapConfig: GazeMapConfig = {};
  GazeMapSettings: GazeMapSettings = {};

  public currentGazeMapConfigSubject: BehaviorSubject<GazeMapConfig> = new BehaviorSubject(this.GazeMapConfig);
  public currentGazeMapConfig!: Observable<GazeMapConfig>;

  public currentGazeMapSettingsSubject: BehaviorSubject<GazeMapSettings> = new BehaviorSubject(this.GazeMapSettings);
  public currentGazeMapSettings!: Observable<GazeMapSettings>;

  constructor(
    private httpClient: HttpClient
  ) { }

  index(queryParams: string, lan: string): Observable<any> {
    return this.httpClient.get(environment.apiMimesysUrl + '/api/results?' + queryParams + "&lang=" + lan);
  }

  show(role: number, testId: string, lan: string, parentEntity: number, mapsDisplay: any, additionalMapsDisplay: any ,videoName?: string): Observable<any> {
    return this.httpClient.get(environment.apiMimesysUrl + '/api/results?internal=true&role=' + role + '&lang=' + lan + '&testId=' + testId + '&parentEntity=' + parentEntity+ '&mapsDisplay=' + mapsDisplay+ '&additionalMapsDisplay=' + additionalMapsDisplay, { params: { 'video': videoName! } });
  }

  update(testId: string, reference: string, privacity: boolean, parentEntityId: number): Observable<any> {
    return this.httpClient.patch(environment.apiMimesysUrl + '/api/result/' + testId, { referencia: reference, privacity: privacity, parentEntityId: parentEntityId });
  }

  destroy(testId: string, data: any): Observable<any> {
    return this.httpClient.delete(environment.apiMimesysUrl + '/api/result/' + testId, { body: data });
  }

  calculateErgo(data: any): Observable<any> {
    return this.httpClient.get(environment.apiMimesysUrl + '/api/calculate/ergo', { params: data });
  }

  count(queryParams: string, lan: string): Observable<any> {
    return this.httpClient.get(environment.apiMimesysUrl + '/api/countResults?' + queryParams);
  }

  public get currentGazeMapConfigValue(): GazeMapConfig {
    return this.currentGazeMapConfigSubject.value;
  }

  public setCurrentGazeMapConfig(_value: GazeMapConfig | null) {

    this.currentGazeMapConfigSubject.next(this.GazeMapConfig)
  }
  public setCurrentGazeMapParamConfig(_param: string, _value: any) {
    this.currentGazeMapConfigSubject.value[_param] = _value;
    this.currentGazeMapConfigSubject.next(this.currentGazeMapConfigSubject.value);
  }

  public get currentGazeMapSettingsValue(): GazeMapSettings {
    return this.currentGazeMapSettingsSubject.value!;
  }

  public setCurrentGazeMapSettings(_value: GazeMapSettings | null) {
    this.currentGazeMapSettingsSubject.next(_value!)
  }
  public setCurrentGazeMapParamSettings(_param: string, _value: any) {
    this.currentGazeMapSettingsSubject.value[_param] = _value;
    this.currentGazeMapSettingsSubject.next(this.currentGazeMapSettingsSubject.value);
    localStorage.setItem('focused_mimesys_settings', JSON.stringify(this.currentGazeMapSettingsSubject.value))
  }

}
